<template>
  <div class="container mt-4">
    <h3>Product List</h3>
    <b-row v-if="NoProductsFound">
      <b-col>
        <b-alert show variant="danger"> No products found. </b-alert>
      </b-col>
    </b-row>
    <b-row v-if="!products">
      <b-col>
        <b-alert show variant="info" > Loading.... </b-alert>
      </b-col>
    </b-row>  
    <b-row>      
      <div v-if="products" class="product-grid">
        <!-- <b-card-group> -->
        <b-card v-for="(item, index) in products" :key="item.Oid"
          :title="item.Name"
          :img-src="item.ImageLink || './static/NoImage.jpg'"
          img-top
          style=""
          class="flex-card mb-4"
          body-class="centered"
        >
          <b-card-text class="centered">{{item.Description}}</b-card-text>
          <b-card-text class="centered">Carton Quantity: {{item.CartonQuantity}}</b-card-text>
          <b-card-text v-if="ShowPrices" class="centered">${{item.Price}}/{{item.UnitOfMeasure}}</b-card-text>
          <b-card-text>Category: {{item.ProductCategoryFullName}}</b-card-text>
          <template #footer>
            <b-input-group>
              <b-input 
                type="number" 
                v-model="item.Qty" 
                :state="item.Qty > 0 ? ProductQtyValid(item) : null"
                :id="`QtyInput${index}`"
              />
              <template #append>
                <b-button @click="AddToCart(item)"><i class="fa fa-shopping-cart" aria-hidden="true" /> Add To Cart</b-button>
              </template>
            </b-input-group>
            <b-form-text v-if="!ProductMeetsMin(item)">Minimum order quantity is {{Math.max(item.Category.MinBuy, item.QuantityMin)}}</b-form-text>
            <b-form-text v-if="!ProductMeetsStepSize(item)">Must order in multiples of {{item.QuantityStepSize}}</b-form-text>
            <b-form-text v-if="!ProductMeetsMax(item)">Maximum order quantity is {{tem.QuantityMax}}</b-form-text>
            <b-card-text>Total Units: {{item.CartonQuantity * item.Qty}}</b-card-text>
          </template>
        </b-card>
      </div>
    </b-row>
      <!-- </b-card-group> -->
    <b-row v-if="MoreAvailable" class="mt-2 text-center">
      <b-col>
        <b-btn :disabled="fetchingProducts" v-on:click="loadMoreProducts" variant="info">{{LoadMoreCaption}}</b-btn>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import ProductService from "../services/ProductService";
import store from "@/store.js";
import NProgress from 'nprogress';
import ShowPrices from '@/mixins/ShowPrices';
import ConfigService from '../services/ConfigService';

function GetProducts(term, skip, done) {
  ProductService.ProductSearch(term, skip, 9)
    .then(response => {
      debugger;
      response.forEach(p => p.Category = ConfigService.GetCategoryByFullName(p.ProductCategoryFullName));
      done(null, response);
    })
    .catch(() => {
      done("unable to get products");
    });
}

export default {
  name: "ProductList",
  props: ["criteria"],
  data() {
    return {
      error: null,
      products: null,
      fetchingProducts: false
    };
  },
  computed: {
    MoreAvailable: function() {
      return (
        this.products == null ||
        (this.products.length > 0 && this.products.length % 9 === 0)
      );
    },
    NoProductsFound: function() {
        return this.products != null && this.products.length == 0;
    },
    LoadMoreCaption: function() {
        return this.fetchingProducts ? 'Loading...' : 'More';
    }
  },
  beforeRouteEnter(to, from, next) {
    GetProducts(to.query.q, 0, (err, products) => {
      next(vm => vm.setData(err, products));
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.products = null;
    GetProducts(to.query.q, 0, (err, products) => {
      this.setData(err, products);
      next();
    });
  },
  methods: {
    setData(err, products) {
      if (err) {
        this.error = err.toString();
      } else {
        this.products = products;
      }
    },
    loadMoreProducts() {
        this.fetchingProducts = true;
        NProgress.start();
        NProgress.set(0.1);
        GetProducts(this.criteria, this.products.length, (err, products) => {
            this.products = this.products.concat(products);
            this.fetchingProducts = false;
            setTimeout(() => NProgress.done(), 500);
        });
    },
    navigateToProduct(number) {
      this.$router.push({ name: "ProductDetail", query: { number: number } });
    },
    
    ProductMeetsMin(product) {
      var applicableMin = Math.max(product.Category.MinBuy, product.QuantityMin);
      if(product.Qty > 0 && applicableMin > 0) {
        return product.Qty >= applicableMin;
      }
      return true;
    },
    ProductMeetsMax(product){
      if(product.Qty > 0 && product.QuantityMax > 0) {
        return product.Qty <= product.QuantityMax;
      }
      return true;
    },
    ProductMeetsStepSize(product){
      if(product.Qty > 0 && product.QuantityStepSize > 0) {
        return product.Qty % product.QuantityStepSize == 0;
      }
      return true;
    },
    ProductQtyValid(product) {
        if(!this.ProductMeetsMin(product) || 
          !this.ProductMeetsMax(product) || 
          !this.ProductMeetsStepSize(product)) {
            return false;
        }
        return true;
    },
    async AddToCart(specificItem) {
      debugger
      if(specificItem) {
        specificItem.ProductCategory = specificItem.ProductCategoryFullName;
        debugger
        this.$store.commit("AddToCart", specificItem);

        this.$toasted
          .success("Added " + specificItem.Name + " products to Cart")
          .goAway(3000);
      }
      else {
        var itemsWithQty = _.filter(this.products, i => i.Qty > 0);

        _.forEach(itemsWithQty, i=> {
          i.ProductCategory = i.ProductCategoryFullName;
          this.$store.commit("AddToCart", i);
        });
        
        this.$toasted
          .success("Added " + itemsWithQty.length + " products to Cart")
          .goAway(3000);
      }
    }
  },
  mixins: [ShowPrices]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.card:hover {
  background: #f1f2f6;
  cursor: pointer;
}

.card-img-top{
  height: 15vw;
  object-fit: scale-down;
}

.flex-card {
  flex: 0 0 auto;
  max-width: 400px;
  min-width: 100%;
}

.product-grid {
  display: grid; 
  grid-auto-flow: columns; 
  gap: 15px 15px; 
  grid-template-columns: 1fr;
}

@media screen and (min-width: 768px) {
  .product-grid {
    display: grid; 
    grid-auto-flow: columns; 
    gap: 15px 15px; 
    grid-template-columns: 1fr 1fr 1fr;
  }

  .flex-card {
    min-width: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/productlist.vue